<script lang="ts">
  // What fills one numbered slot. The kind picks from a closed list; nothing here reads
  // a destination, a URL or a caption from the payload, because none of those exist in
  // a control. The company placed the button — the wording on it is ours.

  import type { CardControl } from '$lib/protocol/types';

  import type { ElementContext } from '../context';
  import AnswerControl from './AnswerControl.svelte';
  import CalendarAddControl from './CalendarAddControl.svelte';
  import CartSubmitControl from './CartSubmitControl.svelte';
  import type { CardState } from './card-state.svelte';
  import QuantityControl from './QuantityControl.svelte';
  import RequestItemsControl from './RequestItemsControl.svelte';

  let {
    control,
    ctx,
    card,
  }: { control: CardControl | undefined; ctx: ElementContext; card: CardState } = $props();
</script>

{#if control === undefined}
  <!-- A slot with no matching control draws nothing. The server rejects such a card, so
       reaching here means something upstream is wrong — and a blank is the honest
       rendering of "we do not know what belongs here". -->
{:else if control.kind === 'quantity' && control.itemId !== undefined}
  <QuantityControl itemId={control.itemId} {card} disabled={ctx.disabled} />
{:else if control.kind === 'request_items'}
  <RequestItemsControl {ctx} {card} />
{:else if control.kind === 'cart_submit'}
  <CartSubmitControl {ctx} cartId={control.cartId} />
{:else if control.kind === 'answer'}
  <AnswerControl {ctx} questionId={control.questionId} />
{:else if control.kind === 'calendar_add'}
  <CalendarAddControl {ctx} eventId={control.eventId} />
{/if}
